import { useCallback, useState } from 'react';

export function useTabs<T extends string>(
  initialTabId: T,
): {
  activeTabId: T;
  setActiveTab: (tabId: T) => void;
  isActive: (tabId: T) => boolean;
} {
  const [activeTabId, setActiveTabId] = useState<T>(initialTabId);

  const setActiveTab = useCallback((tabId: T) => {
    setActiveTabId(tabId);
  }, []);

  const isActive = useCallback((tabId: T) => activeTabId === tabId, [activeTabId]);

  return { activeTabId, setActiveTab, isActive };
}
